export enum AgentProfileStatusEnum {
  APPROVED = 'APPROVED',
  WAIT_APPROVE = 'WAIT_APPROVE',
}

export interface AgentProfileInfo {
  accountId: number;
  createdAt: number;
  createdBy: number;
  id: number;
  status: AgentProfileStatusEnum;
  taxationSystem: string;
  updatedAt: number;
  updatedBy: number;
}
